import { useRouter } from 'next/router';
import Link from 'next/link';

import UseModal from 'hooks/use-modal';

import Card from '@core/components/card/Card';
import Avatar from './Avatar';
import FullNameForm from './FullNameForm';
import LogoutModal from '../settings/LogoutModal';
import Modal from '@core/components/Modal/Modal';

// import styles
import newsLetterImage from 'assets/images/profile-newsletter-card.png';

// import icons
import FAQIcon from 'assets/icons/faq-icon.svg';
import FAQIconImg from 'assets/icons/faq-icon.svg?url';
import OurMissionIcon from 'assets/icons/chart.svg?url';
import BookIcon from 'assets/icons/book-icon.svg';
import GiftIcon from 'assets/icons/gift-icon.svg';
import InstagramIcon from 'assets/icons/instagram-icon.svg';
import LinkedinIcon from 'assets/icons/linkedin-icon.svg';
import TiktokIcon from 'assets/icons/tiktok-icon.svg';
import ReceiptIcon from 'assets/icons/receipt-icon.svg';
import SettingIcon from 'assets/icons/setting-icon.svg';
import MedalStarIcon from 'assets/icons/medal-star-icon.svg';
import ContactIcon from 'assets/icons/contact-icon.svg';
import ContactIconImg from 'assets/icons/contact-icon.svg?url';
import SmsIcon from 'assets/icons/sms-icon.svg';
import CheckIcon from 'assets/icons/check-icon.svg';
import VIPIcon from 'assets/icons/vip-large-icon.svg';
import MyResumeIcon from 'assets/icons/personalcart.svg';
import WishlistIcon from '@core/assets/icons/wishlist.svg?url';
import LogoutIcon from 'assets/icons/logout-icon-pink.svg?url';
import NotificationIcon from 'assets/icons/notification-icon.svg?url';
import MyAccountIcon from 'assets/icons/user-icon-new.svg';

import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import classes from './LoggedInUser.module.scss';

const LoggedInUser = ({ data, refetchHandler }) => {
	const { showModal, destroyModal, show } = UseModal();
	const router = useRouter();

	let origin = '';
	if (router.isReady) {
		if (typeof window !== 'undefined') {
			origin = window.location.origin;
		}
	}
	const {
		showModal: showLogoutModal,
		destroyModal: destroyLogoutModal,
		show: showLogout
	} = UseModal();

	return (
		<>
			<div
				className={`${classes['loggedin-profile-container']} container py-5 d-flex flex-column gap-5 col-12 col-md-10 col-xl-8`}>
				<div className={`${classes['user-box']}`}>
					<Avatar imageURL={data.image} refetchHandler={refetchHandler} />
					<div className={`${classes['info']}`}>
						{data.is_name_verified ? (
							<div
								className={`${classes['fill-name']}`}>{`${data.first_name} ${data.last_name}`}</div>
						) : (
							<div
								className={`${classes['empty-name']}`}
								role="button"
								tabIndex={0}
								onClick={() => showModal()}>
								Add your name
							</div>
						)}
						<div className={`${classes['user-email']}`}>
							{data.email}
							{/* {data.is_verified && <CheckIcon />} */}
						</div>
					</div>
				</div>
				{!data.is_verified && (
					<div className={`${classes['email-not-verified']}`}>
						<div className={`${classes['msg-container']}`}>
							<SmsIcon />
							<div className={`${classes['text']}`}>Email not verified yet</div>
						</div>
						<div className={`${classes['action-container']}`}>
							<Link href="/verification">Verify now</Link>
							<div className={`${classes['icon']}`}></div>
						</div>
					</div>
				)}
				<Modal show={show} closeHandler={destroyModal} type={MOBILE_FULLSCREEN}>
					<FullNameForm closeModal={destroyModal} refetchHandler={refetchHandler} />
				</Modal>
				{data.has_vip_access && (
					<section className={classes['vip-section']}>
						<VIPIcon />
						<h3>Your account is VIP.</h3>
						<p>
							To see what you have access to, check our content for the VIP icon above and enjoy the
							high quality content offered by Pharmuni.
						</p>
					</section>
				)}
				<div className={`${classes['profile-menus']} container d-flex d-xl-grid`}>
					<div className={`${classes['item-icon']}`}>
						<Link href="/profile/my-resume">
							<MyResumeIcon />
							<span className={`${classes['item-icon-label']}`}>My resume</span>
						</Link>
					</div>

					<div className={`${classes['item-icon']}`}>
						<Link href="/certificates">
							<MedalStarIcon />
							<span className={`${classes['item-icon-label']}`}>Certificates</span>
						</Link>
					</div>
					<div className={`${classes['item-icon']}`}>
						<Link href="/order-history">
							<ReceiptIcon />
							<span className={`${classes['item-icon-label']}`}>Order history</span>
						</Link>
					</div>
					<div className={`${classes['item-icon']}`}>
						<Link href="/profile/my-account">
							<MyAccountIcon />
							<span className={`${classes['item-icon-label']}`}>My Account</span>
						</Link>
					</div>
					<div className={`${classes['item-icon']}`}>
						<Link href="/redeem-gift-code">
							<GiftIcon />
							<span className={`${classes['item-icon-label']}`}>Reedem gift code</span>
						</Link>
					</div>
					<div className={`${classes['item-icon']}`}>
						<Link href="/setting">
							<img src={NotificationIcon} alt="wishlist-icon" />
							<span className={`${classes['item-icon-label']}`}>Notification setting</span>
						</Link>
					</div>

					<div className={`${classes['item-icon']} d-block d-xl-none`}>
						<a href={`${origin}/our-mission/`} rel="noreferrer">
							<img src={OurMissionIcon} alt="our-mission-icon" />
							<span className={`${classes['item-icon-label']}`}>Our Mission</span>
						</a>
					</div>
					<div className={`${classes['item-icon']} d-block d-xl-none`}>
						<a href={`${origin}/privacy-policy/`} rel="noreferrer">
							<BookIcon />
							<span className={`${classes['item-icon-label']}`}>Privacy policy</span>
						</a>
					</div>
					<div className={`${classes['item-icon']} d-block d-xl-none`}>
						<Link href="/contact-us">
							<ContactIcon />
							<span className={`${classes['item-icon-label']}`}>Contact us</span>
						</Link>
					</div>
					<div className={`${classes['item-icon']} d-block d-xl-none`}>
						<Link href="/faq">
							<FAQIcon />
							<span className={`${classes['item-icon-label']}`}>FAQ</span>
						</Link>
					</div>
					<div className={`${classes['item-icon-logout']} d-block d-xl-none`}>
						<div role="button" onClick={showLogoutModal}>
							<img src={LogoutIcon} alt="our-mission-icon" />
							<span className={`${classes['item-icon-label']}`}>Log out</span>
						</div>
					</div>
				</div>
				<div
					className={`${classes['desktop-bot-menu']} d-none d-xl-flex flex-row align-items-center justify-content-around`}>
					<div
						className={`${classes['item-icon-logout']} d-flex flex-row align-items-center gap-2`}
						role="button"
						onClick={showLogoutModal}>
						<img src={LogoutIcon} alt="our-mission-icon" />
						<span className={`${classes['item-icon-label']}`}>Log out</span>
					</div>
					<div className={`${classes['item-icon']}`}>
						<Link href="/contact-us" className="d-flex flex-row align-items-center gap-2">
							<img src={ContactIconImg} alt="our-mission-icon" />
							<span className={`${classes['item-icon-label']}`}>Contact us</span>
						</Link>
					</div>
					<div className={`${classes['item-icon']}`}>
						<Link href="/faq" className="d-flex flex-row align-items-center gap-2">
							<img src={FAQIconImg} alt="our-mission-icon" />
							<span className={`${classes['item-icon-label']}`}>FAQ</span>
						</Link>
					</div>
				</div>
				<div className={`${classes['social-media-container']}`}>
					<span>Follow us on</span>
					<div className={`${classes['icons']}`}>
						<a href={data.social_media_urls.instagram_url} target="_blank" rel="noreferrer">
							<InstagramIcon />
						</a>
						<a href={data.social_media_urls.linkedin_url} target="_blank" rel="noreferrer">
							<LinkedinIcon />
						</a>
						{/* <a href={data.social_media_urls.tiktok_url} target="_blank" rel="noreferrer">
							<TiktokIcon />
						</a> */}
					</div>
				</div>
				{data.has_newsletter && (
					<Card
						imageURL={newsLetterImage.src}
						title="don’t miss any big news"
						subTitle="Subscribe to our newsletter to"
						actions={[
							{
								label: 'Subscribe now',
								callback: () => {
									console.log('click on button!');
								}
							}
						]}
					/>
				)}
			</div>
			<Modal header={false} show={showLogout} closeHandler={destroyLogoutModal}>
				<LogoutModal closeModal={destroyLogoutModal} />
			</Modal>
		</>
	);
};

export default LoggedInUser;
